<template>
    <div class="signDialog" v-loading="loading">
        <sign-in-form ref="signInForm"></sign-in-form>
        <sign-in-table ref="signInTable"></sign-in-table>
    </div>
</template>
<script>
import SignInForm from './SignInForm.vue';
import SignInTable from './SignInTable.vue';
import { getUserReceiptDetail } from '@/modules/transport/otp/api/performanceReceiptSign.js';
export default {
    name: 'UserSignInDetail',
    components: {
        SignInForm,
        SignInTable
    },
    props: {
        rowData: {
            type: Object,
            default () {
                return {};
            }
        }
    },
    data () {
        return {
            loading: false,
            signInInfo: {}
        };
    },
    mounted () {
        this.getUserReceiptDetail();
    },
    methods: {
        getUserReceiptDetail () {
            this.loading = true;
            getUserReceiptDetail({ taskNo: this.rowData.taskNo }).then(res => {
                if (res && +res.code === 0) {
                    this.signInInfo = res.data || {};
                    this.$refs.signInForm.initFormData(this.signInInfo);
                    this.$refs.signInTable.initTableData(this.signInInfo.receiptUserDetailQueryResponseDtos || []);
                }
            }).finally(() => {
                this.loading = false;
            });
        }
    }
};
</script>
